export const defaultTableColumns = [
  {
    field: 'contractCode',
    title: '合同编号',
  },
  {
    field: 'contractName',
    title: '合同名称',
  },
  {
    field: 'contractStatus',
    title: '单据状态',
  },
  {
    field: 'companyName',
    title: '公司',
  },
  {
    field: 'applyDepartment',
    title: '业务部门',
  },
  {
    field: 'contractType',
    title: '合同类别',
  },
  {
    field: 'contractTitle',
    title: '合同类型',
  },
  {
    field: 'supplierName',
    title: '供应商名称',
  },
  {
    field: 'salesmanName',
    title: '部门负责人',
  },
  {
    field: 'operaterName',
    title: '经办人',
  },
  {
    field: 'projectNo',
    title: '立项编号',
  },
  {
    field: 'projectName',
    title: '项目名称',
  },
  {
    field: 'contractAmount',
    title: '合同金额',
  },
  {
    field: 'contractUnitAmount',
    title: '合同单价',
  },
  {
    field: 'contractQuantity',
    title: '合同数量',
  },
  {
    field: 'dateStart',
    title: '合同开始日期',
  },
  {
    field: 'dateEnd',
    title: '合同结束日期',
  },
  {
    field: 'contractPenaltyTypeCode',
    title: '合同违约金类型',
  },
  {
    field: 'penaltyTypeValue',
    title: '违约金固定值',
  },
  {
    field: 'penaltyDailyRate',
    title: '违约金日利率',
  },
];
